import type { FaireProductEntity } from "../../entity_types/product";

export const p_nxvdhqkt4d: FaireProductEntity = {
  token: "p_nxvdhqkt4d",
  type: "product",
  name: "Vanilla with M&Ms",
  brandToken: "b_xtvv45q74f",
  brandName: "Meem's Fudge Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/0008d883a53caa4a3e1166a08e8bd58366770d89cfbaaa1b156482f455774dda.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50dc09cd7b691b15f980db8f2400a04c5a0661a27042d30dcea6dfe8531ff55d.png",
    "https://cdn.faire.com/fastly/d9abcade7b1483a896e235e1dd060abea87c4b080d29327a778f98af3796e10c.png",
  ],
  priceDollars: 4.5,
  description:
    "Add a pop of fun to your day with Vanilla Fudge with M&Ms, a treat that’s as vibrant as it is delicious! This creamy, melt-in-your-mouth vanilla fudge is infused with the playful crunch of classic M&Ms, creating a delightful mix of smooth and crunchy textures.\n\nHandcrafted with care, each batch starts with our signature vanilla fudge, made from premium ingredients for a rich, buttery flavor. It’s then studded with colorful M&Ms, adding a cheerful twist that’s perfect for sharing—or keeping all to yourself.\n\nWhether you’re looking for a fun gift, a party favorite, or a sweet pick-me-up, Vanilla Fudge with M&Ms is sure to bring a smile to every face.\n\nWhy You’ll Love It:\n\n * Made with premium, all-natural ingredients \n * A perfect balance of creamy vanilla fudge and crunchy candy pieces \n * Handcrafted in small batches for unbeatable freshness \nBring the fun and flavor home—order your Vanilla Fudge with M&Ms today and let the sweetness brighten your day!\n",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:04.738Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
